import { render, staticRenderFns } from "./No23.vue?vue&type=template&id=68963388&scoped=true"
import script from "./No23.vue?vue&type=script&lang=js"
export * from "./No23.vue?vue&type=script&lang=js"
import style0 from "./No23.vue?vue&type=style&index=0&id=68963388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68963388",
  null
  
)

export default component.exports